export default function() {
  return this.axis().find(d => d.target === 'y');
}


// WEBPACK FOOTER //
// ./layouts/rectLinear/axisY.js